import React from 'react';
import styled, { css } from 'styled-components';
import { useI18n } from '../i18n/index';
import LanguageSwitcher from './LanguageSwitcher';
import { theme } from '../styles/theme';
import { fadeInDown, withMotion } from '../styles/animations';

const AppHeader = () => {
  const { t } = useI18n();

  return (
    <Header>
      <Inner>
        <Left>
          <LogoWrap>
            <img src="/logo.png" alt="" aria-hidden="true" width="44" height="44" />
          </LogoWrap>
          <TitleBlock>
            <Title>{t('app.name')}</Title>
            <Subtitle>{t('app.subtitle')}</Subtitle>
          </TitleBlock>
        </Left>
        <Right>
          <LanguageSwitcher />
        </Right>
      </Inner>
    </Header>
  );
};

const Header = styled.header`
  background: ${theme.colors.surfaceElevated};
  border-bottom: 1px solid ${theme.colors.borderStrong};
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  position: relative;
  z-index: 10;

  ${withMotion(css`
    animation: ${fadeInDown} 0.4s ease both;
  `)}

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
  }
`;

const Inner = styled.div`
  max-width: 920px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.md};
  flex-wrap: wrap;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  flex-wrap: wrap;
  min-width: 0;
`;

const Right = styled.div`
  flex-shrink: 0;
`;

const LogoWrap = styled.div`
  flex-shrink: 0;

  img {
    display: block;
    width: 44px;
    height: 44px;
    object-fit: contain;
    opacity: 0.9;
    filter: drop-shadow(0 0 6px rgba(59,130,246,0.3));
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    display: none;
  }
`;

const TitleBlock = styled.div`
  min-width: 0;
`;

const Title = styled.h1`
  font-size: clamp(17px, 3.5vw, 24px);
  font-weight: 700;
  letter-spacing: -0.3px;
  color: ${theme.colors.textPrimary};
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Subtitle = styled.p`
  font-size: 12px;
  color: ${theme.colors.textSecondary};
  margin-top: 2px;
  letter-spacing: 0.2px;

  @media (max-width: ${theme.breakpoints.mobile}) {
    display: none;
  }
`;


export default AppHeader;
